import React, { PropTypes } from 'react';
import Related from '../../containers/Related';
import { getContentImage, formatDate } from '../../ui-helpers';
import ContentBody from '../../containers/ContentBody';
import { event } from '../../langMap';

const Event = ({
  body, title, edition, mainImage,
  location, from, to, time, id, subtitle, lang,
}) => {
  const { latitude, longitude, address } = location;
  const image = getContentImage(mainImage);
  const style = {
    color: edition.background,
  };
  const backgroundImage = {
    backgroundImage: `url(${image})`,
    marginBottom: '30px',
    paddingTop: '67.058823529412%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: edition.background,
  };

  const formatTime = (eventTime, appLang) => {
    if (appLang !== 'ar') {
      return eventTime;
    }
    return eventTime.replace(/pm|am/, value => (
      value === 'am' ? ' صباحاً' : ' مساءً'
    ));
  };

  return (
    <div className="fold fold--event fold--main fold--main--without-index">
      <div className="fold--main__inner">
        <article className="fold__col fold__col--main">
          <div className="content-col content-col--w-side">
            <header className="fold__col__header">
              <h1 className="fold__col__title">{ title }</h1>
            </header>
            <div className="content-col__main">
              <div className="scroll-wrapper">
                <div className="fold__col__body">
                  {
                    typeof mainImage !== 'undefined' ?
                      <div className="field-main-image" style={backgroundImage} /> :
                      null
                  }
                  {
                    typeof subtitle !== 'undefined' ?
                      <h2 style={style} className="field-sub-title">{ subtitle }</h2> :
                      null
                  }
                  <ContentBody background={edition.background} body={body} />
                </div>
              </div>
            </div>
            <div className="content-col__side">
              <div className="scroll-wrapper">
                <div className="fold__col__side">
                  <dl className="event__info">
                    {
                      from ?
                        <div className="event__info__item">
                          <dt>{lang === 'ar' ? event.date : 'Date'}:</dt>
                          <dd className="event__info__date">{ formatDate(from) }</dd>
                          <dd className="event__info__date">{ formatDate(to) }</dd>
                        </div> : null
                    }
                    {
                      time ?
                        <div className="event__info__item">
                          <dt>{lang === 'ar' ? event.time : 'Time'}:</dt>
                          <dd className="event__info__time">{ formatTime(time, lang) }</dd>
                        </div> : null
                    }
                    <div className="event__info__item">
                      <dt>{lang === 'ar' ? event.location : 'Location'}:</dt>
                      <dd className="event__address">{ address }</dd>
                    </div>
                  </dl>
                  {
                    latitude && longitude ?
                      <div className="event__map">
                        <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}>
                          <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude}, ${longitude}&zoom=18&size=400x400&key=AIzaSyCqq9MFEviJxPrTu0r9KpUgKQ5VvzchwfE`} alt="event map" />
                        </a>
                      </div> : null
                  }
                </div>
              </div>
            </div>
          </div>
          <Related color={edition.background} contentId={id} />
        </article>
      </div>
    </div>
  );
};

export default Event;

Event.propTypes = {
  lang: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  from: PropTypes.string,
  to: PropTypes.string,
  time: PropTypes.string,
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    longitude: PropTypes.string,
    latitude: PropTypes.string,
    address: PropTypes.string,
  }).isRequired,
  subtitle: PropTypes.string,
  mainImage: PropTypes.string,
};

Event.defaultProps = {
  mainImage: undefined,
  subtitle: undefined,
  time: '',
  from: '',
  to: '',
};



// WEBPACK FOOTER //
// ./js/components/happenings/Event.js